export default {
  name: null,
  rules:[],
  static:{
    refundable: false
  }
}